module.exports = __webpack_public_path__ + "static/media/VGT_330.d0301bac.png";